import GEL from "../png/currency/GEL Icon/LARI.png"

export const GelIcon = () => {

  return (
    <img className="h-[20px]" src={GEL} alt="GEL Icon" />
  )
}